import { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import Label from "../shared-components/Label";
import ButtonComponent from "../shared-components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormActionButton from "../shared-components/FormActionButton";
import {
  formPages,
  KOUNT_NEW_ACCOUNT_OPENING,
  STORE_CLIENT_DATA,
  baseUrl,
} from "../../constants";
import { getDocumentPath } from "../../constants/brandDocuments";
import { detectBrand } from "../../utils/brandDetection";
import { BRAND_IDS } from "../../config/brands";
import { collectKountData } from "../../utils/kount";
import { subscribeKlaviyo, trackKlaviyo } from "../../utils/klaviyo";
import { normalizeUkMobile } from "../../utils/utils";
import axios from "axios";
import Popup from "reactjs-popup";
//import { getCreditCheck } from '../../containers/CarFinance/mapper';
import { Button } from "react-bootstrap";
import MarkdownComponent from "../shared-components/MarkDown/MarkdownComponents";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { marked } from "marked";
import "reactjs-popup/dist/index.css";

const DEFAULT_KOUNT_FALLBACK_MOBILE = "07123456789";

// Add CSS for hyperlink-style links and resizable container
const getLinkStyles = (isMLM) => `
  .sign-up-terms {
    background: ${isMLM ? "var(--info-box-bg)" : "none"};
    border: none;
    padding: ${isMLM ? "2px 4px" : "0"};
    border-radius: ${isMLM ? "3px" : "0"};
    color: ${isMLM ? "var(--brand-primary)" : "var(--success-color)"};
    text-decoration: underline;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    font-weight: ${isMLM ? "700" : "inherit"};
  }

  .sign-up-terms:hover {
    color: ${isMLM ? "#8B0000" : "var(--theme-color-2)"};
    background: ${isMLM ? "#F5D5D5" : "none"};
    text-decoration: underline;
  }

  .sign-up-terms:active {
    color: ${isMLM ? "#660000" : "var(--theme-color-1)"};
  }

  /* Document preview modal styles */
  .popup-content {
    width: 95% !important;
    max-width: 1200px !important;
    max-height: 85vh !important;
    border-radius: 12px !important;
    padding: 0 !important;
    border: none !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  }

  .doc-modal {
    display: flex;
    flex-direction: column;
    height: 80vh;
    max-height: 80vh;
  }

  .doc-modal-header {
    display: flex;
    justify-content: flex-end;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    background: #fafafa;
    border-radius: 12px 12px 0 0;
  }

  .doc-modal-close {
    background: none;
    border: none;
    font-size: 28px;
    color: #666;
    cursor: pointer;
    padding: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
  }

  .doc-modal-close:hover {
    background: #eee;
    color: #333;
  }

  .doc-modal-body {
    flex: 1;
    overflow-y: auto;
    padding: 32px 40px;
    line-height: 1.6;
  }

  .doc-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid #eee;
    background: #fafafa;
    border-radius: 0 0 12px 12px;
    display: flex;
    justify-content: center;
  }

  .doc-download-btn {
    background: var(--success-color);
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px 20px;
    color: white;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: opacity 0.2s ease;
  }

  .doc-download-btn:hover {
    opacity: 0.9;
  }

  @media (max-width: 600px) {
    .popup-content {
      width: 95% !important;
      max-height: 90vh !important;
    }
    .doc-modal-body {
      padding: 20px;
    }
  }

  .resizable-terms-container {
    position: relative;
    resize: none;
    overflow: hidden;
  }

  .resize-handle {
    position: absolute;
    bottom: 8px;
    right: 22px;
    width: 24px;
    height: 24px;
    cursor: nw-resize;
    z-index: 10;
    opacity: 0.6;
    transition: opacity 0.2s ease, transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    border: 1px solid var(--light-gray-border);
  }

  .resize-handle:hover {
    opacity: 1;
    transform: scale(1.1);
    background: rgba(255, 255, 255, 0.95);
    border-color: var(--medium-gray);
  }

  .resize-handle svg {
    width: 16px;
    height: 16px;
    color: var(--dark-gray);
  }

  .resize-handle:hover svg {
    color: var(--text-dark);
  }

  .resizing {
    user-select: none;
  }
`;

// export const CRM_SUBMIT_ENDPOINT = () => {
//   return `${baseUrl}/api/create-case`;
// };

export default function Signature({
  compensate,
  onNext,
  onBack,
  isSubmitted,
  setIsSubmitted,
}) {
  const brand = detectBrand();
  const isMLM = brand.id === BRAND_IDS.MLM;
  const [signature, setSignature] = useState(compensate.signature);
  const [kountError, setKountError] = useState("");
  //const [termsConditions, setTermsConditions] = useState(compensate.termsConditions)
  const signatureRef = useRef();
  const [signaturePadWidth, setSignaturePadWidth] = useState();
  // const [signatureOverlay, setSignatureOverlay] = useState(true)

  const [signError, setsignError] = useState(false);
  const [signErrorType, setSignErrorType] = useState(""); // 'empty' or 'minimal'

  // State for resizable terms container (MLM uses taller container)
  const [termsContainerHeight, setTermsContainerHeight] = useState(
    brand.id === BRAND_IDS.MLM ? 200 : 120,
  );
  const [isResizing, setIsResizing] = useState(false);
  const termsContainerRef = useRef();
  //const [termError, setTermError] = useState(false);
  // const marketingAudience = new URLSearchParams(window.location.search).get('utm_term')

  useEffect(() => {
    const updateSignaturePadWidth = () => {
      setSignaturePadWidth(
        signatureRef?.current?._canvas?.parentElement?.clientWidth
      );
    };
    updateSignaturePadWidth();

    const sigPad = signatureRef.current?._sigPad;
    const canvas = signatureRef.current?._canvas;
    if (sigPad && canvas) {
      const originalCreatePoint = sigPad._createPoint.bind(sigPad);
      sigPad._createPoint = (x, y, pressure) => {
        const rect = canvas.getBoundingClientRect();
        const clampedX = Math.min(Math.max(x, rect.left), rect.right);
        const clampedY = Math.min(Math.max(y, rect.top), rect.bottom);
        return originalCreatePoint(clampedX, clampedY, pressure);
      };
    }

    window.addEventListener("resize", updateSignaturePadWidth);
    return () => {
      window.removeEventListener("resize", updateSignaturePadWidth);
    };
  }, []);

  // Handle resize functionality for terms container
  useEffect(() => {
    const handleMove = (e) => {
      if (!isResizing) return;

      const container = termsContainerRef.current;
      if (!container) return;

      const rect = container.getBoundingClientRect();
      const clientY = e.clientY || (e.touches && e.touches[0].clientY);
      const newHeight = Math.max(120, Math.min(300, clientY - rect.top));
      setTermsContainerHeight(newHeight);
    };

    const handleEnd = () => {
      setIsResizing(false);
      document.body.classList.remove("resizing");
    };

    if (isResizing) {
      document.addEventListener("mousemove", handleMove);
      document.addEventListener("mouseup", handleEnd);
      document.addEventListener("touchmove", handleMove);
      document.addEventListener("touchend", handleEnd);
      document.body.classList.add("resizing");
    }

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleEnd);
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("touchend", handleEnd);
      document.body.classList.remove("resizing");
    };
  }, [isResizing]);

  const handleResizeStart = (e) => {
    e.preventDefault();
    setIsResizing(true);
  };

  const clearSig1 = () => {
    signatureRef.current.clear();
    setSignature(false);
    setsignError(false);
    setSignErrorType("");
  };

  const trimToUndefined = (value) => {
    if (typeof value !== "string") {
      return value ?? undefined;
    }

    const trimmed = value.trim();
    return trimmed || undefined;
  };

  const normalizePhoneNumber = (value) => {
    return normalizeUkMobile(value) || undefined;
  };

  const getKountMobileDetails = (payload) => {
    const actualMobile = normalizePhoneNumber(payload?.mobile);
    if (actualMobile) {
      return {
        mobileNumber: actualMobile,
        mobileProvided: true,
        mobileSource: "user",
      };
    }

    const fallbackMobile = normalizePhoneNumber(
      process.env.REACT_APP_KOUNT_FALLBACK_MOBILE ||
        DEFAULT_KOUNT_FALLBACK_MOBILE,
    );

    return {
      mobileNumber: fallbackMobile,
      mobileProvided: false,
      mobileSource: "synthetic",
    };
  };

  const normalizeDateOfBirth = (value) => {
    const trimmed = trimToUndefined(value);
    if (!trimmed) {
      return undefined;
    }

    const slashMatch = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (slashMatch) {
      const [, day, month, year] = slashMatch;
      return `${year}-${month}-${day}`;
    }

    return trimmed;
  };

  const buildKountAddress = (address) => {
    const currentAddress = {
      line1: trimToUndefined(address?.Line1),
      line2: trimToUndefined(address?.Line2),
      city: trimToUndefined(address?.City),
      postcode: trimToUndefined(address?.PostalCode),
    };

    return Object.values(currentAddress).some(Boolean)
      ? currentAddress
      : undefined;
  };

  const buildSubmissionPayload = async (payload) => {
    setKountError("");

    const kountData = await collectKountData(payload?.email);
    const mobile = normalizePhoneNumber(payload?.mobile);
    return {
      ...payload,
      ...(payload?.mobile !== undefined && { mobile: mobile || "" }),
      kountResponse: {
        ...(payload.kountResponse || {}),
        ...kountData,
      },
    };
  };

  const buildKountIdentityPayload = (payload) => {
    const kountMobile = getKountMobileDetails(payload);
    const kountResponse = payload?.kountResponse || {};

    return {
      sessionId: kountResponse.kountSessionId,
      clientReference:
        trimToUndefined(payload?.uniqueID) ||
        trimToUndefined(payload?.email) ||
        kountResponse.kountSessionId,
      title: trimToUndefined(payload?.title),
      forename: trimToUndefined(payload?.firstName) || "",
      middleName: trimToUndefined(payload?.middleName),
      surname: trimToUndefined(payload?.surname) || "",
      dateOfBirth: normalizeDateOfBirth(payload?.dob),
      email: trimToUndefined(payload?.email),
      mobileNumber: kountMobile.mobileNumber,
      currentAddress: buildKountAddress(payload?.currentAddress),
      kountMobileNumberProvided: kountMobile.mobileProvided,
      kountMobileNumberUsed: kountMobile.mobileNumber,
      kountMobileNumberSource: kountMobile.mobileSource,
    };
  };

  const fetchWebsiteAcquisitionIpAddress = async () => {
    const ipResponse = await axios.get(`${baseUrl}/api/1.0/ip_address`, {
      headers: {
        accept: "application/json",
        "x-api-key": "w439RKAhrjMLBbYLgqp3JG5HPK9BjbCcPhW5ISWnUZQ=",
      },
    });

    return ipResponse?.data?.address || null;
  };

  const submitFinalPayload = async (submissionPayload, signatureValue) => {
    try {
      const response = await STORE_CLIENT_DATA({
        ...submissionPayload,
        // KYC journey (details confirmed on ConfirmDetails) uses the same
        // email route as the direct ConfirmDetails submission
        ...(compensate.detailsConfirmed && {
          emailRoute: "kyc_confirm_details",
        }),
      });

      // Subscribe to marketing email + SMS after CRM consent
      subscribeKlaviyo(
        submissionPayload.email,
        window.location.href,
        submissionPayload.mobile,
        {
          firstName: submissionPayload.firstName,
          lastName: submissionPayload.surname,
        },
      );

      trackKlaviyo('Submitted', {
        url: window.location.href,
        page_name: 'Signature',
        email: submissionPayload.email,
      });

      onNext(
        {
          signature: signatureValue,
          uniqueID: response?.uniqueID || compensate.uniqueID,
        },
        formPages.RequestFinanceLender,
      );
    } catch (error) {
      console.error("Error sending email on signature submit:", error);
      onNext(
        {
          signature: signatureValue,
        },
        formPages.RequestFinanceLender,
      );
    }
  };

  const handleKountDecision = async (submissionPayload, signatureValue) => {
    const identityPayload = buildKountIdentityPayload(submissionPayload);

    try {
      const kountResponse = await KOUNT_NEW_ACCOUNT_OPENING(identityPayload);
      const decision = `${kountResponse?.decision || ""}`.trim().toUpperCase();
      const transactionId = kountResponse?.transactionId || null;
      const status =
        `${kountResponse?.status || ""}`.trim().toUpperCase() || null;

      const enrichedPayload = {
        ...submissionPayload,
        kountRequest: identityPayload,
        kountResponse: {
          ...(submissionPayload.kountResponse || {}),
          kountMobileNumberProvided:
            identityPayload.kountMobileNumberProvided ?? null,
          kountMobileNumberUsed: identityPayload.kountMobileNumberUsed || null,
          kountMobileNumberSource:
            identityPayload.kountMobileNumberSource || null,
          kountDecision: decision || null,
          kountTransactionId: transactionId,
          kountStatus: status,
          kountDecisionedAt: new Date().toISOString(),
        },
      };

      await submitFinalPayload(enrichedPayload, signatureValue);
    } catch (error) {
      const kountErrorMessage =
        error?.response?.data?.detail ||
        error?.message ||
        "We couldn't complete the KOUNT verification step right now.";

      const fallbackPayload = {
        ...submissionPayload,
        kountRequest: identityPayload,
        kountResponse: {
          ...(submissionPayload.kountResponse || {}),
          kountMobileNumberProvided:
            identityPayload.kountMobileNumberProvided ?? null,
          kountMobileNumberUsed: identityPayload.kountMobileNumberUsed || null,
          kountMobileNumberSource:
            identityPayload.kountMobileNumberSource || null,
          kountDecision: null,
          kountTransactionId: null,
          kountStatus: "FAILED",
          kountDecisionedAt: new Date().toISOString(),
          kountError: kountErrorMessage,
        },
      };

      setKountError(kountErrorMessage);
      await submitFinalPayload(fallbackPayload, signatureValue);
    }
  };

  const handleDownload = (pdfFile, fileName) => {
    // Fetch the PDF file dynamically based on the parameter
    fetch(pdfFile)
      .then((response) => response.blob())
      .then((blob) => {
        // Create a URL for the Blob object
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);

        // Append the link to the body
        document.body.appendChild(link);

        // Simulate a click to trigger the download
        link.click();

        // Remove the link from the document
        link.parentNode.removeChild(link);
      })
      .catch((err) => console.error("Error downloading the file:", err));
  };

  const downloadMarkdownAsPDF = async (
    markdownPath,
    fileName,
    isCompact = false,
  ) => {
    try {
      // Fetch the markdown file
      const response = await fetch(markdownPath);
      const markdownText = await response.text();

      // Convert markdown to HTML with tables enabled
      marked.setOptions({
        breaks: true,
        gfm: true, // GitHub Flavored Markdown (includes tables)
      });
      const htmlContent = marked(markdownText);

      // Create a temporary div to parse HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;

      // Create PDF with compact settings for Key Facts (single-sided FCA requirement)
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = isCompact ? 10 : 15;
      const maxWidth = pageWidth - margin * 2;
      let yPosition = margin;

      // Process each element
      const elements = tempDiv.children;

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const tagName = element.tagName.toLowerCase();

        // Handle tables
        if (tagName === "table") {
          const tableData = [];
          const headers = [];

          // Extract headers
          const thead = element.querySelector("thead");
          if (thead) {
            const headerRow = thead.querySelector("tr");
            if (headerRow) {
              const ths = headerRow.querySelectorAll("th");
              ths.forEach((th) => headers.push(th.textContent.trim()));
            }
          }

          // Extract body rows
          const tbody = element.querySelector("tbody");
          if (tbody) {
            const rows = tbody.querySelectorAll("tr");
            rows.forEach((row) => {
              const rowData = [];
              const cells = row.querySelectorAll("td");
              cells.forEach((cell) => rowData.push(cell.textContent.trim()));
              if (rowData.length > 0) {
                tableData.push(rowData);
              }
            });
          }

          // Check if we need a new page for the table
          if (yPosition > pageHeight - 60) {
            pdf.addPage();
            yPosition = margin;
          }

          // Add table using autoTable with compact settings for Key Facts
          autoTable(pdf, {
            head: headers.length > 0 ? [headers] : undefined,
            body: tableData,
            startY: yPosition,
            margin: { left: margin, right: margin },
            styles: {
              fontSize: isCompact ? 7 : 10,
              cellPadding: isCompact ? 1.5 : 3,
            },
            headStyles: {
              fillColor: [51, 132, 188], // Blue color
              textColor: 255,
              fontStyle: "bold",
              fontSize: isCompact ? 7 : 10,
            },
            alternateRowStyles: {
              fillColor: [245, 245, 245],
            },
            theme: "grid",
          });

          yPosition = pdf.lastAutoTable.finalY + (isCompact ? 3 : 10);
          continue;
        }

        // Handle lists
        if (tagName === "ul" || tagName === "ol") {
          const listItems = element.querySelectorAll("li");
          pdf.setFontSize(isCompact ? 8 : 11);
          pdf.setFont(undefined, "normal");

          listItems.forEach((li, index) => {
            const bullet = tagName === "ul" ? "• " : `${index + 1}. `;
            const text = li.textContent.trim();
            const lines = pdf.splitTextToSize(bullet + text, maxWidth - 5);

            const lineHeight = pdf.getLineHeight() / pdf.internal.scaleFactor;
            const blockHeight = lines.length * lineHeight;

            if (yPosition + blockHeight > pageHeight - margin) {
              pdf.addPage();
              yPosition = margin;
            }

            pdf.text(lines, margin + 5, yPosition);
            yPosition += blockHeight + (isCompact ? 1 : 3);
          });

          yPosition += isCompact ? 2 : 5; // Extra spacing after list
          continue;
        }

        // Handle regular text elements
        let text = element.textContent.trim();
        if (!text) continue;

        // Set font based on element type with compact sizes for Key Facts
        if (tagName === "h1") {
          pdf.setFontSize(isCompact ? 12 : 20);
          pdf.setFont(undefined, "bold");
          yPosition += isCompact ? 2 : 5; // Extra space before heading
        } else if (tagName === "h2") {
          pdf.setFontSize(isCompact ? 10 : 16);
          pdf.setFont(undefined, "bold");
          yPosition += isCompact ? 2 : 5;
        } else if (tagName === "h3") {
          pdf.setFontSize(isCompact ? 9 : 14);
          pdf.setFont(undefined, "bold");
          yPosition += isCompact ? 1.5 : 3;
        } else if (tagName === "h4") {
          pdf.setFontSize(isCompact ? 8.5 : 12);
          pdf.setFont(undefined, "bold");
          yPosition += isCompact ? 1.5 : 3;
        } else if (
          element.querySelector("strong") ||
          element.querySelector("b")
        ) {
          pdf.setFontSize(isCompact ? 8 : 11);
          pdf.setFont(undefined, "bold");
        } else {
          pdf.setFontSize(isCompact ? 8 : 11);
          pdf.setFont(undefined, "normal");
        }

        // Split text to fit page width
        const lines = pdf.splitTextToSize(text, maxWidth);

        // Check if we need a new page
        const lineHeight = pdf.getLineHeight() / pdf.internal.scaleFactor;
        const blockHeight = lines.length * lineHeight;

        if (yPosition + blockHeight > pageHeight - margin) {
          pdf.addPage();
          yPosition = margin;
        }

        // Add text to PDF
        pdf.text(lines, margin, yPosition);
        yPosition += blockHeight + (isCompact ? 2 : 5); // Add spacing after block
      }

      // Save the PDF
      pdf.save(fileName);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    }
  };
  const termsAndConditions = (text) => {
    return (
      <Popup trigger={<button className="sign-up-terms">{text}</button>} modal>
        {(close) => (
          <div className="doc-modal">
            <div className="doc-modal-header">
              <button className="doc-modal-close" onClick={close}>
                ×
              </button>
            </div>
            <div className="doc-modal-body">
              <MarkdownComponent
                filePath={getDocumentPath("termsConditions")}
              />
            </div>
            <div className="doc-modal-footer">
              <button
                className="doc-download-btn"
                onClick={() =>
                  downloadMarkdownAsPDF(
                    getDocumentPath("termsConditions"),
                    "Terms-and-Conditions.pdf",
                  )
                }
              >
                <FontAwesomeIcon icon={["fa", "download"]} />
                Download PDF
              </button>
            </div>
          </div>
        )}
      </Popup>
    );
  };

  const privacyPolicy = () => {
    return (
      <Popup
        trigger={<button className="sign-up-terms">Privacy Policy</button>}
        modal
      >
        {(close) => (
          <div className="doc-modal">
            <div className="doc-modal-header">
              <button className="doc-modal-close" onClick={close}>
                ×
              </button>
            </div>
            <div className="doc-modal-body">
              <MarkdownComponent filePath={getDocumentPath("privacyPolicy")} />
            </div>
            <div className="doc-modal-footer">
              <button
                className="doc-download-btn"
                onClick={() =>
                  downloadMarkdownAsPDF(
                    getDocumentPath("privacyPolicy"),
                    "Privacy-Policy.pdf",
                  )
                }
              >
                <FontAwesomeIcon icon={["fa", "download"]} />
                Download PDF
              </button>
            </div>
          </div>
        )}
      </Popup>
    );
  };

  const mlmFees = () => {
    return (
      <Popup trigger={<button className="sign-up-terms">Fees</button>} modal>
        {(close) => (
          <div className="doc-modal">
            <div className="doc-modal-header">
              <button className="doc-modal-close" onClick={close}>
                ×
              </button>
            </div>
            <div className="doc-modal-body">
              <MarkdownComponent filePath={getDocumentPath("mlmFees")} />
            </div>
            <div className="doc-modal-footer">
              <button
                className="doc-download-btn"
                onClick={() =>
                  downloadMarkdownAsPDF(
                    getDocumentPath("mlmFees"),
                    "MLM-Fees.pdf",
                  )
                }
              >
                <FontAwesomeIcon icon={["fa", "download"]} />
                Download PDF
              </button>
            </div>
          </div>
        )}
      </Popup>
    );
  };

  const mlmTerms = () => {
    return (
      <Popup
        trigger={
          <button className="sign-up-terms">
            MLM Terms and Agreement Pack
          </button>
        }
        modal
      >
        {(close) => (
          <div className="doc-modal">
            <div className="doc-modal-header">
              <button className="doc-modal-close" onClick={close}>
                ×
              </button>
            </div>
            <div className="doc-modal-body">
              <MarkdownComponent filePath={getDocumentPath("dbaTerms")} />
            </div>
            <div className="doc-modal-footer">
              <button
                className="doc-download-btn"
                onClick={() =>
                  downloadMarkdownAsPDF(
                    getDocumentPath("dbaTerms"),
                    "MLM-Terms-and-DBA.pdf",
                  )
                }
              >
                <FontAwesomeIcon icon={["fa", "download"]} />
                Download PDF
              </button>
            </div>
          </div>
        )}
      </Popup>
    );
  };

  const valid8PrivacyPolicy = () => {
    return (
      <a
        href="https://www.valid8.co.uk/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="sign-up-terms"
      >
        Valid8 Privacy Policy
      </a>
    );
  };

  const mlmPrivacyPolicy = () => {
    return (
      <Popup
        trigger={<button className="sign-up-terms">MLM Privacy Policy</button>}
        modal
      >
        {(close) => (
          <div className="doc-modal">
            <div className="doc-modal-header">
              <button className="doc-modal-close" onClick={close}>
                ×
              </button>
            </div>
            <div className="doc-modal-body">
              <MarkdownComponent
                filePath={getDocumentPath("mlmPrivacyPolicy")}
              />
            </div>
            <div className="doc-modal-footer">
              <button
                className="doc-download-btn"
                onClick={() =>
                  downloadMarkdownAsPDF(
                    getDocumentPath("mlmPrivacyPolicy"),
                    "MLM-Privacy-Policy.pdf",
                  )
                }
              >
                <FontAwesomeIcon icon={["fa", "download"]} />
                Download PDF
              </button>
            </div>
          </div>
        )}
      </Popup>
    );
  };

  const keyFacts = () => {
    return (
      <Popup
        trigger={<button className="sign-up-terms">Key Facts</button>}
        modal
      >
        {(close) => (
          <div className="doc-modal">
            <div className="doc-modal-header">
              <button className="doc-modal-close" onClick={close}>
                ×
              </button>
            </div>
            <div className="doc-modal-body">
              <MarkdownComponent filePath={getDocumentPath("keyFacts")} />
            </div>
            <div className="doc-modal-footer">
              <button
                className="doc-download-btn"
                onClick={() =>
                  downloadMarkdownAsPDF(
                    getDocumentPath("keyFacts"),
                    "MLM-Key-Facts.pdf",
                    true,
                  )
                }
              >
                <FontAwesomeIcon icon={["fa", "download"]} />
                Download PDF
              </button>
            </div>
          </div>
        )}
      </Popup>
    );
  };

  const representationConsentStatement = () => {
    return (
      <Popup
        trigger={
          <button className="sign-up-terms">Representation Statement</button>
        }
        modal
      >
        {(close) => (
          <div className="doc-modal">
            <div className="doc-modal-header">
              <button className="doc-modal-close" onClick={close}>
                ×
              </button>
            </div>
            <div className="doc-modal-body">
              <MarkdownComponent
                filePath={getDocumentPath("representationConsentStatement")}
              />
            </div>
            <div className="doc-modal-footer">
              <button
                className="doc-download-btn"
                onClick={() =>
                  downloadMarkdownAsPDF(
                    getDocumentPath("representationConsentStatement"),
                    "Representation-Consent-Statement.pdf",
                  )
                }
              >
                <FontAwesomeIcon icon={["fa", "download"]} />
                Download PDF
              </button>
            </div>
          </div>
        )}
      </Popup>
    );
  };

  /*const importantFacts = () =>{
    return  <Popup trigger={<button className='sign-up-terms'>Key Facts</button>} modal>
              {close =>(
              <div style={{ height: '500px', overflowY: 'auto'}}>
                <Button label='X' style={{position: 'absolute', right:'0', top: '0', borderRadius: '0', backgroundColor: '#198754', padding: '2px 5px', fontSize: 'smaller'}} onClick={close}>
                  X
                </Button>
                <MarkdownComponent filePath='/files/Claims1-MLM-Key-Facts.md' /> <button onClick={() => handleDownload('/files/Claims1-MLM-Key-Facts.pdf', 'Claims1-MLM-Key-Facts.pdf')}>Download as PDF</button>
              </div>
              )}
            </Popup>
  }*/

  const termsText = () => {
    return (
      <div
        className="card"
        style={{
          border: "1px solid var(--light-gray-border)",
          borderRadius: "8px",
          padding: "20px",
          backgroundColor: "var(--light-gray-bg)",
        }}
      >
        <p className="mb-3" style={{ fontSize: "12px", lineHeight: "1.3" }}>
          By signing above and pressing the "Submit" button below, I confirm
          that I have read and agree to the important information below:
        </p>

        <div className="mb-3" style={{ position: "relative" }}>
          <div
            ref={termsContainerRef}
            className="terms-scroll-container resizable-terms-container"
            style={{
              height: `${termsContainerHeight}px`,
              overflowY: "auto",
              padding: "20px",
              paddingBottom: "25px",
              backgroundColor: "var(--white-bg)",
              border: "1px solid var(--light-gray-border)",
              borderRadius: "8px",
              fontSize: "11px",
              lineHeight: "1.4",
            }}
          >
            <p className="mb-3">
              I was not fully informed regarding the commission paid by{" "}
              {brand.id === BRAND_IDS.MLM
                ? "my lender or lender group to the dealer who sold my car"
                : "the lender to the dealer when I purchased my vehicle"}
              .
            </p>
            {brand.id === BRAND_IDS.MLM ? (
              <>
                <p className="mb-3">
                  I consent for My Law Matters to act on my behalf to make a
                  motor finance claim(s) to my lender(s) on a no-win, no-fee
                  basis. I understand that, if My Law Matters are successful in
                  securing compensation for me, I will be charged a success fee
                  of between 15% to 30% plus VAT (18% to 36% in total) of the
                  compensation received.
                </p>
                <p className="mb-3">
                  I have read and agree to the {mlmTerms()}, {privacyPolicy()},{" "}
                  {keyFacts()} and {representationConsentStatement()}. I agree
                  for my digital signature to be applied to these documents,
                  copies of which will be e-mailed to me.
                </p>
                <p className="mb-3">
                  I authorise My Law Matters to conduct identity verification
                  and soft credit searches on my behalf through Valid8 IP Ltd,
                  with no impact on my credit score. I also agree to{" "}
                  {valid8PrivacyPolicy()}.
                </p>
                <p className="mb-3">
                  I understand I do not have to use a law firm, and I can make a
                  claim myself directly to my lender or the Financial Ombudsman
                  Service at no cost.
                </p>
              </>
            ) : (
              <>
                <p className="mb-3">
                  I have read and agree to{" "}
                  {termsAndConditions(
                    `${brand.displayName} Terms of Engagement & Authority`,
                  )}
                  , {privacyPolicy()} and {keyFacts()}.
                </p>
                <p className="mb-3">
                  I consent to {brand.displayName} referring my claim(s) to My
                  Law Matters (MLM), who will act on a no-win no-fee basis, and
                  if successful will charge {mlmFees()}. I have read and agree
                  to the {mlmTerms()}, {mlmPrivacyPolicy()} and{" "}
                  {representationConsentStatement()}. I agree for my digital
                  signature to be applied to these documents and e-mailed to me.
                  I authorise MLM to conduct identity verification and soft
                  credit searches on my behalf through Valid8 IP Ltd (Valid8),
                  with no impact on my credit score and agree to{" "}
                  {valid8PrivacyPolicy()}. I understand I can make a claim
                  myself directly to my lender or the Financial Ombudsman
                  Service at no cost.
                </p>
                {/* <p className="mb-3">
                  I understand I can make a claim myself directly to my lender
                  or the Financial Ombudsman Service at no cost.
                </p> */}
              </>
            )}
          </div>
          <div
            className="resize-handle"
            onMouseDown={handleResizeStart}
            onTouchStart={handleResizeStart}
            title="Drag to resize"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15,3 21,3 21,9" />
              <polyline points="9,21 3,21 3,15" />
              <line x1="21" y1="3" x2="14" y2="10" />
              <line x1="3" y1="21" x2="10" y2="14" />
            </svg>
          </div>
        </div>
      </div>
    );
  };
  /*const creditCheckRequest = async() =>{
    setIsSubmitted(true)
    try {
      const response = await axios.post(CREDIT_CHECK(), getCreditCheck(compensate));
        const returnedData = response?.data?.message?.response?.data
        const previousAddresses = response?.data?.message?.response?.previous_addresses

       if(returnedData && previousAddresses){
        setIsSubmitted(false)
        let updatedClaims = [...returnedData]; // Copy the external claims data

        if (!compensate.creditCheckSuccess && compensate.registrationDetails) {
          const hasRegistrationDetailsObject = updatedClaims.some(
            claim => claim.reg && claim.reg !== ''
          );

          if (!hasRegistrationDetailsObject && compensate.registrationDetails.yearOfManufacture < 2021) {
            updatedClaims.push({
              lender_name: '',
              finance_agreement_number: '',
              date_finance_was_taken: '',
              account_type: '',
              make: compensate?.registrationDetails?.make,
              new_or_used: compensate.purchasedRegCar,
              vehicleRegistrationNumber: compensate.registrationDetails.registrationNumber,
              vehicleMakeYear: compensate.registrationDetails.yearOfManufacture.toString()
            });
          }
        }
        onNext({
          claims: updatedClaims,
          termsConditions,
          signature,
          previousAddress: [...(compensate.previousAddress || []), ...previousAddresses]
        },(formPages.CreditCheckSuccess))
       }else if(returnedData && !previousAddresses){
        setIsSubmitted(false)
        let updatedClaims = [...returnedData]; // Copy the external claims data

        if (!compensate.creditCheckSuccess && compensate.registrationDetails) {
          const hasRegistrationDetailsObject = updatedClaims.some(
            claim => claim.reg && claim.reg !== ''
          );

          if (!hasRegistrationDetailsObject && compensate?.registrationDetails?.yearOfManufacture < 2021) {
            updatedClaims.push({
              lender_name: '',
              finance_agreement_number: '',
              date_finance_was_taken: '',
              account_type: '',
              make: compensate?.registrationDetails?.make,
              new_or_used: compensate.purchasedRegCar,
              vehicleRegistrationNumber: compensate.registrationDetails.registrationNumber,
              vehicleMakeYear: compensate.registrationDetails.yearOfManufacture.toString()
            });
          }
        }
        onNext({
          claims: updatedClaims,
          termsConditions,
          signature,
        },(formPages.CreditCheckSuccess))
      }
    } catch (error) {
      console.error('Error fetching credit check:', error)
      setIsSubmitted(false)
      onNext({
        claims: (() => {
          let updatedClaims = [...(compensate?.claims || [])];

          // Add object if credit check failed and registration details exist, but only if there's no object with a non-blank 'reg' key
          if (compensate.registrationDetails) {
            const hasRegistrationDetailsObject = updatedClaims.some(
              claim => claim.vehicleRegistrationNumber && claim.vehicleRegistrationNumber !== ''
            );

          // Add object if credit check failed and registration details exist
          if (!hasRegistrationDetailsObject && compensate.registrationDetails.yearOfManufacture < 2021) {
            updatedClaims.push({
              lender_name: '',
              finance_agreement_number: '',
              date_finance_was_taken: '',
              account_type: '',
              make: compensate?.registrationDetails?.make,
              new_or_used: compensate.purchasedRegCar,
              vehicleRegistrationNumber: compensate.registrationDetails.registrationNumber,
              vehicleMakeYear: compensate.registrationDetails.yearOfManufacture.toString()
            });
          }
        }
          return updatedClaims;
        })(),
        termsConditions,
        signature,
      },(compensate.registrationDetails.yearOfManufacture < 2021 ? formPages.CreditCheckSuccess : formPages.RequestFinanceLender))
    }
  }*/

  return (
    <>
      <style>{getLinkStyles(isMLM)}</style>
      <div
        className="d-flex justify-content-center row align-items-center heading-icon fdc-form"
        data-testid="page-signature"
        style={{ paddingBottom: "0" }}
      >
        <h2 className="title" style={{ marginBottom: "0" }}>
          Review and sign below and we will handle the rest.
        </h2>
      </div>
      <div className="fdc-form gif-input">
        <div className="row">
          <div className="col-md-12">
            <div className="form-block">
              <Label
                label={
                  <span style={{ fontWeight: 700 }}>
                    Please sign in the box below
                  </span>
                }
              />
              <div style={{ position: "relative", marginBottom: "20px" }}>
                <div
                  className="signature"
                  data-testid="signature-canvas-wrapper"
                  style={{
                    background: "var(--pink-color) 0% 0% no-repeat padding-box",
                    border: "1px solid var(--input-border)",
                  }}
                >
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{ height: 150, width: signaturePadWidth }}
                    onEnd={() => {
                      const strokeData = signatureRef.current.toData();

                      const isMinimalSignature = () => {
                        if (strokeData.length === 0) return true;
                        if (strokeData.length === 1 && strokeData[0].length === 1) return true;
                        const dotCount = strokeData.filter((stroke) => stroke.length === 1).length;
                        if (dotCount >= strokeData.length && strokeData.length <= 3) return true;
                        const shortStrokes = strokeData.filter((stroke) => stroke.length < 3).length;
                        if (shortStrokes >= strokeData.length && strokeData.length <= 2) return true;
                        const totalPoints = strokeData.reduce((sum, stroke) => sum + stroke.length, 0);
                        if (totalPoints < 5) return true;
                        return false;
                      };

                      if (isMinimalSignature()) {
                        signatureRef.current.clear();
                        setSignature("");
                        setsignError(true);
                        setSignErrorType("minimal");
                      } else {
                        setSignature(signatureRef.current._sigPad.toDataURL("image/png"));
                        setsignError(false);
                        setSignErrorType("");
                      }
                    }}
                    ref={signatureRef}
                  />
                </div>
                <ButtonComponent
                  label={<FontAwesomeIcon icon={["fa", "rotate"]} />}
                  onClick={clearSig1}
                  className="transparent"
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    minWidth: "0",
                    zIndex: "1000",
                    padding: "0",
                  }}
                />
              </div>
              {/*signatureOverlay && <ButtonComponent
              className={'remove-animation'}
              label={<><FontAwesomeIcon icon={["fa" , "signature"]} size='4x' /> <br /> Click here and write your signature as it appears on your ID </>}
              onClick={() => setSignatureOverlay(false)}
              style={{textAlign: 'center', minWidth:'100%', height: '162px', marginTop: '-230px', zIndex: "2000", position: "relative", backgroundColor: 'var(--success-color)', borderRadius: '0'}}
            />*/}
              {signError ? (
                <div className="error-message">
                  <p>
                    {signErrorType === "minimal"
                      ? "Please provide a complete signature above. Initials, dots, or abbreviated marks cannot be accepted."
                      : "Please provide a signature."}
                  </p>
                </div>
              ) : (
                <></>
              )}
              <div className="t-and-c-check">
                {/* <ListRadioOptions
                  items={[{ text:"Click here to confirm your consent to the conditions below", value: true} ]}
                  onSelect={(value) => {
                    setTermsConditions(!termsConditions)
                    if(value === true){
                      setTermError(false)
                    }
                  }}
                  value={termsConditions}
                  className="ps-0 no-radius"
              />*/}
                {/*termError ?
                <div>
                  <span className="text-danger">
                  <p>Please click the box above to confirm</p>
                  </span>
              </div>
              :<></>
              */}
                {termsText()}
              </div>
            </div>
          </div>
          {kountError ? (
            <div className="col-md-10 mx-auto mt-3">
              <div className="error-message">
                <p>{kountError}</p>
              </div>
            </div>
          ) : null}
          <div className="col-md-6 mx-auto text-center">
            <FormActionButton
              nextTestId="signature-btn-submit"
              onNext={async () => {
                // Prevent double-click/multiple submissions
                if (isSubmitted) {
                  return;
                }
                setIsSubmitted(true);

                try {
                  // Enhanced validation for blank signature
                  const isSignatureEmpty = () => {
                    // Check if signature state is empty
                    if (
                      !signature ||
                      signature === "" ||
                      signature === undefined
                    ) {
                      return true;
                    }

                    // Check if canvas is empty
                    if (signatureRef.current && signatureRef.current.isEmpty()) {
                      return true;
                    }

                    return false;
                  };

                  if (isSignatureEmpty()) {
                    setsignError(true);
                    // Only set to 'empty' if not already 'minimal' (preserve minimal error type)
                    if (signErrorType !== "minimal") {
                      setSignErrorType("empty");
                    }
                    return;
                  }

                  if (signature) {
                    try {
                      const clientIp = await fetchWebsiteAcquisitionIpAddress();
                      const { ipAddress: _ipAddress, ...compensateWithoutIp } =
                        compensate;
                      const submissionPayload = await buildSubmissionPayload({
                        ...compensateWithoutIp,
                        signature,
                        websiteAquisitionIpAddress: clientIp,
                      });
                      await handleKountDecision(submissionPayload, signature);
                    } catch (error) {
                      console.error(
                        "Error processing KOUNT on signature submit:",
                        error,
                      );
                      setKountError(
                        error?.response?.data?.detail ||
                          error?.message ||
                          "We couldn't complete the KOUNT verification step right now.",
                      );
                    }
                  }
                } finally {
                  // Always re-enable button, even if there were errors or early returns
                  setIsSubmitted(false);
                }
              }}
              nextTitle="Submit"
            />
          </div>
        </div>
      </div>
    </>
  );
}
